import React from "react"
import CText from "../../../common/CText"
import { View, TouchableOpacity } from "react-native";
import CImage from "../../../common/CImage";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import CustomButton from "../../../common/CustomButton";

const Header = (props) => {
  
  const styles = useStyles();
  return (
    <View style={styles.headerWrapper}>
        <View style={styles.menuBar}>
            <TouchableOpacity onPress={() => props.onPress(props.navigation)}>
              <CImage.backIcon />
            </TouchableOpacity>
            <CText.basicInformation style={{fontSize:14}}>{props.title}</CText.basicInformation>
        </View>
        <View style={styles.descViewStyle}>
          <CText.kycDesc> {props.showIcon && 
            <View style={{marginRight:7}}>
               <CImage._infoIcon />
          </View>}
          {props.descText}
          </CText.kycDesc> 
        </View>
       
        {
          props.isShowSkipButton
          ? <View style={styles.buttonViewStyle}>
             <CustomButton text="Skip for now" skipButton={true} onPress={() => props.onSkipPress()} />
             </View>
          : ( props.showDesc ? <View style={styles.showDescWidget}>
             <CText.kycDesc >{"We've got you covered"}</CText.kycDesc> 
              <View style={{marginLeft:10}}> 
                 <CImage.CarIcon /> 
               </View>
             </View> : null) 
        }
        
    </View>
    
  );
};
const useStyles = CreateResponsiveStyle(
  {
    menuBar: {
      flexDirection: "row",
      alignItems: "center",
      gap:13
    },
    titleStyle:{
      fontSize:16
    },
    descViewStyle:{
      display:"flex"
    },
    buttonViewStyle:{
      display:"flex",
      alignItems:'center'
    },
    headerWrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: "center",
        width: '100%',
        height: 70,
        borderRadius: 12,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.06)",
        shadowOffset: {
          width: 0,
          height: 3
        },
        shadowRadius: 6,
        shadowOpacity: 1,
        marginBottom:39,
        paddingHorizontal:30
        
    },
    showDescWidget:{
      alignItems:"center",
      justifyContent:"center",
      flexDirection:"row"}

  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      descViewStyle:{
        display:"none"
      },
      buttonViewStyle:{
        display:"flex",
        marginHorizontal:5
      },
      titleStyle:{
        fontSize:12
      },
      headerWrapper:{
        paddingHorizontal:20,
        flexDirection:'column',
        alignItems:'flex-start'
      },
      showDescWidget:{
        alignSelf:'flex-end'
      },
      buttonViewStyle:{
        alignSelf:'flex-end',
      },

    },
    [DEVICE_SIZES.XS]: {
      descViewStyle:{
        display:"none"
      },
      buttonViewStyle:{
        display:"flex",
        marginHorizontal:5
      },
      titleStyle:{
        fontSize:12
      },
      headerWrapper:{
        paddingHorizontal:20,
        flexDirection:'column',
        alignItems:'flex-start'
      },
      showDescWidget:{
        alignSelf:'flex-end'
      },
      buttonViewStyle:{
        alignSelf:'flex-end',
      },
    }
  }
)

export default Header;

